export default "__VITE_ASSET__ThNBEqU4__"